





































import Modal from "../../core/Modals/Modal.vue";
import ContactSelect from "../../core/Forms/ContactSelect.vue";
import { Contact } from "../../models/Contact";

export default {
    name: "AssignCoproprieteModal",
    components: { Modal, ContactSelect },
    props: {
        showModal: Boolean,
        copropriete_name: String,
    },
    data() {
        return {
            selectedClient: null,
            contactSelectFilters: [Contact.EType.Copropriete],
        };
    },
    methods: {
        closeModal() {
            this.selectedClient = null;
            this.$emit("close-modal");
        },
        assignClient() {
            if (this.selectedClient) {
                this.$emit("assign-client", this.selectedClient);
                this.closeModal();
            }
        },
    },
    watch: {
        showModal(newVal) {
            if (!newVal) {
                this.selectedClient = null;
            }
        },
    },
};
